import { createFileRoute } from '@tanstack/react-router'
import { ClinicProfileTab } from '@/features/settings'

/** C-10 Clinic profile. "Today" for holidays is the clinic's (D-21), from the membership's time zone. */
export const Route = createFileRoute('/_authed/clinics/$clinicId/settings/profile')({
  component: function ProfileRoute() {
    const { timeZone } = Route.useRouteContext()
    return <ClinicProfileTab timeZone={timeZone} />
  },
})
